import { may, type CanHolder } from "../../lib/access";

/**
 * Attachment affordances (ADR-API-09: the server re-checks every write),
 * answered by the incident's `can` ([F-027]).
 */

/** May upload files or add link attachments (`attachment.add`, F-006). */
export function canAddAttachment(incident: CanHolder | null | undefined): boolean {
  return may(incident, "attachment.add");
}

/** May administratively remove an attachment (`attachment.remove`, F-017). */
export function canRemoveAttachment(incident: CanHolder | null | undefined): boolean {
  return may(incident, "attachment.remove");
}
